import { apiAvailableLanguagesResponse, apiLanguageTranslationsResponse } from "../types/api/languageApi";
import { abstractApiCaller } from "./apiCaller";

class LanguageApi extends abstractApiCaller {

    public async getAvailableLanguages (){
        const endpoint = 'api/languages';

        this.abortRequest();

        return await this.queryApiL<apiAvailableLanguagesResponse>(endpoint);
    }

    public async getTranslationsLanguage (iso: string) {

        if (iso === '') {
            return;
        }

        const endpoint = 'api/language/' + iso;

        this.abortRequest();

        return await this.queryApiL<apiLanguageTranslationsResponse>(endpoint);
    }
};

export  { LanguageApi };
